import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-zoomin",
  "use": "icon-zoomin-usage",
  "viewBox": "0 0 174.667 174.858",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 174.667 174.858\" id=\"icon-zoomin\">\r\n<rect x=\"46.667\" y=\"83.666\" fill=\"currentColor\" width=\"81.333\" height=\"11.333\" />\r\n<rect x=\"81.667\" y=\"48.666\" fill=\"currentColor\" width=\"11.333\" height=\"81.332\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol